import{ FC, ReactNode } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { history } from '../config';

interface RouterProps {
    children?: ReactNode;
}

const Router: FC<RouterProps> = ({ children }) => {
    const ConnectedRouterWithChildren = ConnectedRouter as React.ComponentType<{ history: typeof history; children?: ReactNode }>;
    return <ConnectedRouterWithChildren history={history}>{children}</ConnectedRouterWithChildren>;
};

export default Router;
